import Nav from '../../Global/Nav.vue'

export default {
  name: 'Customers',
  components: {
    Nav
  },
  data() {
    return {
      activeName: 'distribute',
      distributeKeywords: '',
      distributeLoading: false,
      distributeList: [],
      distributeVisible: false,
      distributeFormLoading: false,
      distributeForm: {
        id: '',
        title: '',
        platform_email: '',
        worktimes: [0, 24],
        chosenSalers: []
      },
      distributeFormRules: {
        platform_email: [
          { required: true, message: '平台邮箱不能为空' }
        ]
      },
      platformEmailsList: [],
      salersList: [],
      worktimeMarks: {
        0: "-",
        6: "6点",
        12: "12点",
        18: "18点",
        24: "+"
      },

      platformEmailsKeywords: '',
      platformEmailsLoading: false,
      platformEmailsTableList: [],
      platformEmailsVisible: false,
      platformEmailsFormLoading: false,
      platformEmailsFormUsernameDisabled: false,
      platformEmailsForm: {
        id: '',
        username: '',
        password: ''
      },
      platformEmailsFormRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'commit' }
        ]
      }
    }
  },
  mounted() {
    this.queryDistribute();
    setTimeout(() => {
      this.current_page = 1;
      this.queryDistribute();
    }, 0)
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'distribute':
          this.queryDistribute();
          break;
        case 'platform_emails':
          this.queryPlatformEmails();
          break;
      }
    },
    queryDistribute() {
      this.distributeLoading = true;
      let keywords = this.distributeKeywords;
      this.$axios.get('/mailer/distribute/list', {
        params: {
          keywords: keywords
        }
      }).then((response) => {
        this.distributeLoading = false
        if (response.data.code === 200) {
          this.distributeList = response.data.data;
        }
      })
    },
    filterSalers(query, item) {
      return item.label.indexOf(query) > -1;
    },
    async editDistribute(object = null) {
      if (object !== null) {
        this.distributeForm = {
          id: object.id,
          title: object.title,
          platform_email: object.platform_email_id,
          worktimes: object.worktimes,
          chosenSalers: object.chosenSalers
        }
      } else {
        this.distributeForm = {
          id: '',
          title: '',
          platform_email: '',
          worktimes: [0, 24],
          chosenSalers: []
        }
      }
      this.distributeVisible = true;
      this.distributeFormLoading = true;
      await this.$axios.get(`/mailer/distribute/platform_emails`).then((response) => {
        this.platformEmailsList = response.data.data;
      })
      await this.$axios.get(`/mailer/distribute/salers_list`).then((response) => {
        this.salersList = response.data.data.map(v => ({
          key: v,
          label: v
        }))
      })
      this.distributeFormLoading = false;
    },
    submitDistribute() {
      this.$refs.distributeForm.validate(valid => {
        if (valid) {
          this.$confirm('保存后将立即生效, 确定吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.distributeFormLoading = true;
            this.$axios.post(`/mailer/distribute/save`, this.distributeForm).then((response) => {
              this.distributeFormLoading = false;
              if (response.data.code === 200) {
                this.$notify({
                  type: 'success',
                  title: '保存成功'
                })
                this.distributeVisible = false;
                this.queryDistribute();
              }
            })
          })
        }
      })
    },
    toggleDistributeStatus(row, index) {
      let notice = row.status ? '确定开启吗?' : '关闭后本平台的邮件将停止分发, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/mailer/distribute/toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response === undefined) {
            this.distributeList[index].status = !row.status;
          }
          if (response.data.code === 200) {
            this.$notify({
              title: message + '成功',
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.distributeList[index].status = !row.status;
      });
    },
    deleteDistribute(row) {
      this.$confirm('此操作不可恢复, 确定删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/mailer/distribute/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              type: 'success',
              title: '删除成功'
            })
            this.queryDistribute();
          }
        })
      })
    },


    queryPlatformEmails() {
      this.platformEmailsLoading = true;
      let keywords = this.platformEmailsKeywords;
      this.$axios.get('/mailer/distribute/platform_emails_list', {
        params: {
          keywords: keywords
        }
      }).then((response) => {
        this.platformEmailsLoading = false;
        if (response.data.code === 200) {
          this.platformEmailsTableList = response.data.data;
        }
      })
    },
    async editPlatformEmails(object = null) {
      this.platformEmailsFormUsernameDisabled = object !== null;
      if (object !== null) {
        this.platformEmailsForm = {
          id: object.id,
          username: object.username,
          password: object.password
        }
      } else {
        this.platformEmailsForm = {
          id: '',
          username: '',
          password: ''
        }
      }
      this.platformEmailsVisible = true;
    },
    async submitPlatformEmails() {
      await this.$refs.platformEmailsForm.validate(valid => {
        if (valid) {
          this.platformEmailsFormLoading = true;
          this.$axios.post(`/mailer/distribute/platform_emails_save`, this.platformEmailsForm).then((response) => {
            this.platformEmailsFormLoading = false;
            if (response.data.code === 200) {
              this.$notify({
                type: 'success',
                title: '保存成功'
              })
              this.$axios.get(`/mailer/distribute/platform_emails`).then((response) => {
                this.platformEmailsList = response.data.data;
              })
              this.platformEmailsVisible = false;
              this.queryPlatformEmails();
            }
          })
        }
      })
    },
    togglePlatformEmailStatus(row, index) {
      let message = row.status ? '开启' : '关闭';
      let notice = '确定' + message + '吗?';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/mailer/distribute/platform_emails_toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response === undefined) {
            this.platformEmailsTableList[index].status = !row.status;
          }
          if (response.data.code === 200) {
            this.$notify({
              title: message + '成功',
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.platformEmailsTableList[index].status = !row.status;
      });
    },
    deletePlatformEmails(row) {
      this.$confirm('此操作不可恢复, 确定删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/mailer/distribute/platform_emails_delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              type: 'success',
              title: '删除成功'
            })
            this.queryPlatformEmails();
          }
        })
      })
    }
  },
  beforeDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Distribute/script.js